<template>
  <section
    class="min-h-screen flex items-center justify-center bg-gradient-to-br from-annapolis-navy via-annapolis-charcoal to-annapolis-teal-dark"
    aria-labelledby="hero-heading"
  >
    <div class="container mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-20 text-center">
      <!-- Logo -->
      <div class="mb-6 sm:mb-8 flex justify-center">
        <img
          src="/logo.png"
          alt="Annapolis Labs logo - Professional software solutions company"
          class="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 rounded-2xl"
          aria-hidden="true"
        />
      </div>

      <!-- Company Name -->
      <h1
        id="hero-heading"
        class="text-fluid-4xl sm:text-fluid-5xl md:text-fluid-6xl lg:text-fluid-7xl font-bold text-white mb-4 sm:mb-6"
      >
        Annapolis Labs
      </h1>

      <!-- Tagline -->
      <p class="text-fluid-lg sm:text-fluid-xl md:text-fluid-2xl text-gray-300 mb-8 sm:mb-10 md:mb-12 max-w-4xl mx-auto leading-relaxed">
        Professional software tools for developers and businesses. Security, licensing, and infrastructure solutions that work.
      </p>

      <!-- CTA Buttons -->
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
        <a
          href="#contact"
          class="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-annapolis-teal hover:bg-annapolis-teal/90 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg focus:outline-none focus:ring-2 focus:ring-annapolis-teal focus:ring-offset-2 focus:ring-offset-annapolis-navy touch-target"
          aria-label="Contact us for more information"
        >
          Contact Us
        </a>
        <a
          href="#products"
          class="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-transparent border-2 border-annapolis-teal text-annapolis-teal hover:bg-annapolis-teal hover:text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg focus:outline-none focus:ring-2 focus:ring-annapolis-teal focus:ring-offset-2 focus:ring-offset-annapolis-navy touch-target"
          aria-label="Explore our products"
        >
          Explore Products
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
/**
 * HeroSection component displays the main hero section with logo and call-to-action
 * @component
 * @example
 * <HeroSection />
 */
defineOptions({
  name: 'HeroSection'
})
</script>

<style scoped>
.logo-remove-white {
  mix-blend-mode: multiply;
  filter: contrast(1.2) brightness(1.1);
}
</style>
